import React from "react";
import { Modal } from "antd";
import FormSelfcareAttribute from "../formSelfcareAttribute/formSelfcareAttribute";

const ModalSelfcareAttribute = ({
    visible,
    onClose,
    states,
    setters,
    newSelfcareAttribute,
    saveSelfcareAttribute,
    onDeleteAllBehaviors,
}) => {
    return (
        <Modal
            title={newSelfcareAttribute ? "Crear nuevo atributo de autocuidado" : "Editar atributo de autocuidado"}
            open={visible}
            onCancel={onClose}
            footer={null}
            width="80%"
            maskClosable={false}
        >
            <FormSelfcareAttribute
                {...states}
                {...setters}
                newSelfcareAttribute={newSelfcareAttribute}
                saveSelfcareAttribute={saveSelfcareAttribute}
                onDeleteAllBehaviors={onDeleteAllBehaviors}
            />
        </Modal>
    );
};

export default ModalSelfcareAttribute;
